export default __webpack_public_path__ + "static/media/NIAS0160.34I-32762_-17896_0.30f7823e.jpg";